<template>
  <!-- <dv-full-screen-container> -->
  <div class="basic-container" style="background: url(images/bg.png) cover;">
    <div
      id="top-header"
      v-show="$hideHeader != 1"
      style="background: url(images/head.png);background-position: center;background-repeat: no-repeat;"
    >
      <!-- <dv-decoration-8 class="header-left-decoration" /> -->
      <!-- <dv-decoration-5 class="header-center-decoration" /> -->
      <!-- <dv-decoration-8 class="header-right-decoration" :reverse="true" /> -->
      <div class="center-title">
        {{ pageTitle }}
      </div>

      <div class="username">
        <span>{{ authUserInfo.realName }}</span>
      </div>

      <div class="toWZ" @click="gotoWz()" v-show="page_config.showPc">
        进入微站管理平台
      </div>
      <div class="user-profile">
        <span class="quit" @click="quit">退出</span>
      </div>
    </div>

    <!-- <div class="basic-header" v-show="$hideHeader != 1">{{ pageTitle }}</div> -->
    <router-view />
  </div>
  <!-- </dv-full-screen-container> -->
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Config from "@/config";
export default {
  name: "BasicLayout",
  computed: {
    ...mapState(["page_config", "authUserInfo"]),
    ...mapGetters(["pageTitle"]),
    isIE() {
      //ie?
      if (window.ActiveXObject || "ActiveXObject" in window) {
        return true;
      } else if (
        navigator.userAgent.toLowerCase().match(/rv:([\d.]+)\) like gecko/)
      ) {
        return true;
      } else if (navigator.userAgent.indexOf("Edge") > -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    quit() {
      this.$store.commit("setAuthUserInfo", {});
      this.$store.commit("setStations", []);
      this.$store.commit("setStationDict", {});
      this.$store.commit("setStationData", null);
      this.$store.commit("setVirtualStationData", []);
      this.$store.commit("setDataTime", "0");
      sessionStorage.setItem(Config.TOKEN_KEY, "");
      sessionStorage.removeItem("10015_yc_token");
      this.$router.replace({ name: "login" });
      location.reload();
    },
    gotoWz() {
      window.location.href = "/pc/main/index.html";
    }
  }
};
</script>

<style lang="less">
.basic-container {
  background-color: #091933;
  height: 100vh;
}

// .basic-header {
//   background: url(~@/assets/header.png) no-repeat center;
//   background-size: cover;
//   height: 7.41vh;
//   color: rgb(255, 255, 255);
//   font-size: 3.2vh;
//   text-align: center;
//   line-height: 7.41vh;
//   width: 100%;
//   margin-bottom: 2vh;
// }

#top-header {
  position: relative;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  flex-shrink: 0;

  .header-center-decoration {
    width: 40%;
    height: 60px;
    margin-top: 30px;
  }

  .header-left-decoration,
  .header-right-decoration {
    width: 25%;
    height: 60px;
  }

  .center-title {
    position: absolute;
    font-size: 30px;
    font-weight: bold;
    left: 50%;
    top: 25px;
    transform: translateX(-50%);
    color: #fff;
  }

  .toWZ {
    position: absolute;
    top: 6.6vh;
    right: 3.6vw;
    width: 7vw;
    height: 3.2vh;
    line-height: 3.2vh;
    background-color: #081e4c;
    color: #fff;
    border: 1px solid rgb(38, 69, 114);
    border-radius: 5px;
    box-shadow: 0 0 3px;
    cursor: pointer;
  }
}
.username {
  position: absolute;
  right: 3vw;
  bottom: 0.8vh;
  font-size: 19px;
  color: white;
  margin-right: 10px;
}
.user-profile {
  position: absolute;
  right: 1vw;
  bottom: 1vh;
  .quit {
    font-size: 16px;
    color: #41dcff;
    cursor: pointer;
  }
}
</style>
